import { adminHttpClient } from '../../../commons/adminHttpClient'

export interface PerksProgramGeneralDetails {
  mainPhoneNumber: string
  benefit: ProgramBenefitDetails
  primaryAdmin: ProgramPrimaryAdminBenefitDetails
  id: string
  name: string
}

export interface ProgramBenefitDetails {
  benefitStartDate: string
  notificationDate: string
  benefitDesignStatus: string
}

export interface ProgramPrimaryAdminBenefitDetails {
  firstName: string
  lastName: string
  workPhone: string
  workEmail: string
  identificationNumber: string
  id: string
}

const getPerksProgramDetails = (companyId: string, planPeriodId: string): Promise<PerksProgramGeneralDetails> => {
  return adminHttpClient.get(`Csi/Companies/Perks/GetPerksProgramDetails/${companyId}/${planPeriodId}`)
}

export default getPerksProgramDetails
